import { ReactNode } from 'react'

import { MessageDescriptor } from '@lingui/core'

import svgCheckmarkSrc from '@cowprotocol/assets/cow-swap/checkmark.svg'
import iconRefundSrc from '@cowprotocol/assets/cow-swap/icon-refund.svg'
import svgSpinnerSrc from '@cowprotocol/assets/cow-swap/spinner.svg'
import svgXSrc from '@cowprotocol/assets/cow-swap/x.svg'

import { msg } from '@lingui/core/macro'
import SVG from 'react-inlinesvg'
import styled from 'styled-components/macro'

import { StyledSpinnerIcon, StyledRefundCompleteIcon } from '../../styles'
import { SwapAndBridgeStatus } from '../../types'

const StyledStatusCheckmarkIcon = styled(SVG)`
  width: 24px;
  height: 18px;
  color: inherit;
`

const StyledStatusCloseIcon = styled(SVG)`
  color: inherit;
  width: 18px;
  height: 18px;
`
/**
 * This module centralizes all status-related constants for the bridge module
 * It contains icons and text for different status states across both
 * swap and bridge operations.
 */

const CloseIcon = <StyledStatusCloseIcon src={svgXSrc} />

// Base set of icons for status states, used by both swap and bridge
export const commonStatusIcons: Record<SwapAndBridgeStatus, ReactNode> = {
  [SwapAndBridgeStatus.DONE]: <StyledStatusCheckmarkIcon src={svgCheckmarkSrc} />,
  [SwapAndBridgeStatus.PENDING]: <StyledSpinnerIcon src={svgSpinnerSrc} />,
  [SwapAndBridgeStatus.FAILED]: CloseIcon,
  [SwapAndBridgeStatus.REFUND_COMPLETE]: CloseIcon,
  [SwapAndBridgeStatus.DEFAULT]: null,
}

// Swap has custom icons for different states
export const swapStatusIcons: Record<SwapAndBridgeStatus, ReactNode> = {
  ...commonStatusIcons,
  [SwapAndBridgeStatus.FAILED]: <SVG src={iconRefundSrc} />,
  [SwapAndBridgeStatus.REFUND_COMPLETE]: <StyledRefundCompleteIcon src={iconRefundSrc} />,
}

// Bridge uses the common icons without modification
export const bridgeStatusIcons = commonStatusIcons

// Title text used for different swap states
export const swapStatusTitlePrefixes: Record<SwapAndBridgeStatus, MessageDescriptor> = {
  [SwapAndBridgeStatus.DONE]: msg`Swapped on`,
  [SwapAndBridgeStatus.PENDING]: msg`Swapping on`,
  [SwapAndBridgeStatus.FAILED]: msg`Swap failed`,
  [SwapAndBridgeStatus.REFUND_COMPLETE]: msg`Swap refunded`,
  [SwapAndBridgeStatus.DEFAULT]: msg`Swap on`,
}

// Reusable text for different states
export const bridgeFailedTitle: MessageDescriptor = msg`Bridge failed on`

// Title text used for different bridge states
export const bridgeStatusTitlePrefixes: Record<SwapAndBridgeStatus, MessageDescriptor> = {
  [SwapAndBridgeStatus.DONE]: msg`Bridged via`,
  [SwapAndBridgeStatus.PENDING]: msg`Bridging via`,
  [SwapAndBridgeStatus.FAILED]: bridgeFailedTitle,
  [SwapAndBridgeStatus.REFUND_COMPLETE]: bridgeFailedTitle,
  [SwapAndBridgeStatus.DEFAULT]: msg`Bridge via`,
}
